import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PayPalCheckout = ({ items }) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API}/payments/config`)
      .then((r) => setConfig(r.data))
      .catch(() => setError("Payments are unavailable right now."));
  }, []);

  if (error) {
    return (
      <p className="text-sm text-ash" data-testid="paypal-error">
        {error}
      </p>
    );
  }
  if (!config) {
    return <Loader2 className="h-4 w-4 text-gold animate-spin mx-auto" data-testid="paypal-loading" />;
  }
  if (!config.client_id) {
    return (
      <p className="text-xs uppercase tracking-[0.2em] text-ash/70 text-center" data-testid="paypal-pending-credentials">
        PayPal checkout activates once credentials are added
      </p>
    );
  }

  return (
    <div data-testid="paypal-checkout-buttons">
      <PayPalScriptProvider options={{ clientId: config.client_id, currency: config.currency }}>
        <PayPalButtons
          style={{ color: "gold", shape: "pill", label: "pay", height: 48 }}
          forceReRender={[JSON.stringify(items)]}
          createOrder={async () => {
            const { data } = await axios.post(`${API}/payments/paypal/create`, {
              items,
              origin_url: window.location.origin,
            });
            return data.order_id;
          }}
          onApprove={async (d) => {
            await axios.post(`${API}/payments/paypal/capture`, { order_id: d.orderID });
            navigate(`/payment/success?order_id=${d.orderID}`);
          }}
          onCancel={() => navigate("/payment/cancel")}
          onError={() => setError("PayPal could not start — please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
};
